module.exports = __webpack_public_path__ + "img/GT.bc5b62b6.svg";